module.exports = __webpack_public_path__ + "img/50n.a98bb5ba.gif";